/*
  wires the desktop native sort select into focal's own facet refresh
  mechanism. the mobile sort trigger and the filter button need no script of
  their own: both are plain toggle-button elements that already open
  focal's existing sort-by-popover / filter drawer through the aria-controls
  wiring built into theme.js -- this file only replaces what that popover's
  hidden radio inputs do for the select

  mirrors js/custom-element/section/facet/sort-by-popover.js exactly: build
  the destination url, drop any page param so a sort change starts back at
  page 1, then hand off to <product-facet> via the same bubbling
  facet:criteria-changed event it already listens for

  ---------------------------------------------------------------------------
  the listener is delegated on `document`, and that is the whole point of this
  file's shape. binding it directly to the select -- which is what this did
  first -- made sorting work exactly once and then go dead.

  measured rather than reasoned about: marking every ancestor of the select and
  sorting once showed that focal's ProductFacet._rerender replaces the
  *contents* of #facet-main, so the select, its form,
  .kludi-collection-toolbar__sort-form, .kludi-collection-toolbar__meta and
  .product-facet__meta-bar all come back as new nodes while #facet-main and
  everything above it survives. a listener bound at script-evaluation time is
  attached to a node that the first refresh throws away, and the replacement
  select carries nothing.

  delegation rather than a <kludi-sort-select> custom element, which is the
  pattern the rest of this theme uses (kludi-pagination lives in this very same
  replaced region and documents the upgrade-on-connect property it relies on).
  two reasons it is the wrong tool here: an element wrapping the select changes
  the toolbar's own dom, and the toolbar has geometry assertions measured
  against the design; and delegation on document survives a full section reload
  in the theme editor too, not only a facet refresh, with no upgrade step of its
  own. `change` bubbles, so there is nothing to work around.
*/
(function () {
  if (window.__kludiToolbarSortBound) return;
  window.__kludiToolbarSortBound = true;

  document.addEventListener('change', (event) => {
    const select = event.target.closest?.('[data-kludi-toolbar-sort-select]');
    if (!select) return;

    const currentUrl = new URL(window.location.href);
    currentUrl.searchParams.set('sort_by', select.value);
    currentUrl.searchParams.delete('page');

    select.dispatchEvent(new CustomEvent('facet:criteria-changed', {
      bubbles: true,
      detail: { url: currentUrl.toString() },
    }));
  });
})();
